let React = require('react');
let ReactDOM = require('react-dom');
require('./module.scss');

let Tooltip = React.createClass({
  propTypes: {
    content: React.PropTypes.string.isRequired,
    children: React.PropTypes.node.isRequired,
  },

  getInitialState: function() {
    return {
      isVisible: false,
      position: { top: 0, left: 0, direction: 'top' },
      tooltipSize: { width: 0, height: 0 } // 存储Tooltip尺寸
    };
  },

  componentDidMount: function() {
    this._isMounted = true;
  },

  showTooltip: function() {
    clearTimeout(this.timer);
    this.timer = setTimeout(function() {
      if (this._isMounted) {
        // 先渲染透明Tooltip获取尺寸
        this.setState({ isVisible: true, isMeasuring: true }, function() {
          // 在回调中获取尺寸后更新位置
          this.updatePosition();
        });
      }
    }.bind(this), 100);
  },

  hideTooltip: function() {
    clearTimeout(this.timer);
    if (this._isMounted) {
      this.setState({ isVisible: false, isMeasuring: false });
    }
  },

  // 获取Tooltip尺寸
  measureTooltip: function(tooltipNode) {
    if (tooltipNode && this.state.isMeasuring) {
      this.setState({
        tooltipSize: {
          width: tooltipNode.offsetWidth,
          height: tooltipNode.offsetHeight
        },
        isMeasuring: false // 测量完成
      }, this.updatePosition);
    }
  },

  updatePosition: function() {
    try {
      let targetRect = this.refs.target.getBoundingClientRect();
      let scrollY = window.scrollY || document.documentElement.scrollTop;
      let scrollX = window.scrollX || document.documentElement.scrollLeft;
      let tooltipHeight = this.state.tooltipSize.height || 100; // 默认高度

      // 计算可用空间（考虑Tooltip高度）
      let spaceAbove = targetRect.top - tooltipHeight - 10; // 10px安全边距
      let spaceBelow = window.innerHeight - targetRect.bottom - tooltipHeight - 10;

      let direction = spaceAbove > 0 ? 'top' : 'bottom';

      // 精确计算位置（考虑Tooltip高度）
      let topPosition;
      if (direction === 'top') {
        topPosition = targetRect.top + scrollY - tooltipHeight - 10; // 上移Tooltip高度+10px
      } else {
        topPosition = targetRect.bottom + scrollY + 10; // 下移10px
      }

      this.setState({
        position: {
          top: topPosition,
          left: targetRect.left + scrollX + targetRect.width / 2,
          direction: direction,
        }
      });
    } catch (error) {
      console.error('Tooltip position error:', error);
    }
  },

  renderTooltipToBody: function() {
    if (!this.state.isVisible) {
      if (this.tooltipContainer) {
        ReactDOM.unmountComponentAtNode(this.tooltipContainer);
        document.body.removeChild(this.tooltipContainer);
        this.tooltipContainer = null;
      }
      return;
    }

    if (!this.tooltipContainer) {
      this.tooltipContainer = document.createElement('div');
      document.body.appendChild(this.tooltipContainer);
    }

    let position = this.state.position;
    let tooltipClass = 'tooltip ' + position.direction;
    let contentHtml = { __html: this.props.content };
    let style = {
      top: position.top + 'px',
      left: position.left + 'px',
      transform: 'translateX(-50%)',
      opacity: this.state.isMeasuring ? 0 : 1 // 测量时透明
    };

    ReactDOM.unstable_renderSubtreeIntoContainer(
      this,
      <div
        ref={this.measureTooltip} // 新增：测量节点
        className={tooltipClass}
        style={style}
      >
        <div className="tooltip-content" dangerouslySetInnerHTML={contentHtml} />
        <div className="tooltip-arrow" />
      </div>,
      this.tooltipContainer
    );
  },

  componentDidUpdate: function() {
    this.renderTooltipToBody();
  },

  componentWillUnmount: function() {
    this._isMounted = false;
    clearTimeout(this.timer);
    if (this.tooltipContainer) {
      ReactDOM.unmountComponentAtNode(this.tooltipContainer);
      document.body.removeChild(this.tooltipContainer);
    }
  },

  render: function() {
    return (
      <span
        ref="target"
        className="tooltip-target"
        onMouseEnter={this.showTooltip}
        onMouseLeave={this.hideTooltip}
      >
        {this.props.children}
      </span>
    );
  },
});

module.exports = Tooltip;



// WEBPACK FOOTER //
// ./component/toolTip/index.js